import { ApolloClient } from '@apollo/client';
import gql from 'graphql-tag';

import { CommentVisibility } from '../../../interfaces/ChangeOrderComment';

/*
 * GraphQL Mutation for creating a quote change order comment.
 */
export const createQuoteChangeOrderCommentMutation = gql`
  mutation quoteCOCreateComment(
    $changeOrderId: ID!
    $message: String!
    $visibility: QuoteCOCommentVisibility!
  ) {
    quoteCOCreateComment(
      changeOrderId: $changeOrderId
      message: $message
      visibility: $visibility
    )
  }
`;

interface CreateQuoteChangeOrderCommentInput {
  changeOrderId: string;
  message: string;
  visibility: CommentVisibility;
}

interface CreateQuoteChangeOrderCommentResponse {
  quoteCOCreateComment: boolean | null;
}

export async function createQuoteChangeOrderComment(
  client: ApolloClient<object>,
  input: CreateQuoteChangeOrderCommentInput
): Promise<boolean> {
  try {
    const response = await client.mutate<CreateQuoteChangeOrderCommentResponse>({
      mutation: createQuoteChangeOrderCommentMutation,
      variables: {
        changeOrderId: input.changeOrderId,
        message: input.message,
        visibility: input.visibility
      }
    });

    return response.data?.quoteCOCreateComment !== false;

  } catch (err) {
    throw new Error(`Failed to create quote change order comment: ${err}`);
  }
}
